import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "root-header" };
const _hoisted_2 = {
    key: 0,
    class: "sub-title-text"
};
const _hoisted_3 = { class: "option-area" };
const _hoisted_4 = {
    key: 1,
    title: "유저 네임",
    class: "ml-1"
};
const _hoisted_5 = {
    class: "mr-2",
    title: "계정 종류"
};
const _hoisted_6 = { class: "ml-1 mr-2" };
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "btn-area" };
import { computed, onMounted, } from 'vue';
import { useRouter } from 'vue-router';
import vuexStore from '@/vuex-store';
import { routeName } from '@/constants/routeName';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { pageTypeList } from '@/constants/userManagement/pageTypeList';
import HubSelector from '@/components/HubSelector.vue';
import MapConfigButton from '@/views/MapControl/Header/MapConfigButton.vue';
import { userActionType } from '@/vuex-store/user/actions';
import { userGetterType } from '@/vuex-store/user/getters';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Gnb',
    setup(__props) {
        const router = useRouter();
        const userId = computed(() => vuexStore.getters[userGetterType.userId]);
        const userName = computed(() => vuexStore.getters[userGetterType.userName]);
        const userLevelNameKr = computed(() => vuexStore.getters[userGetterType.userLevelNameKr]);
        const distributorName = computed(() => vuexStore.getters[userGetterType.distributorName]);
        const distributorId = computed(() => vuexStore.getters[userGetterType.distributorId]);
        const hubName = computed(() => vuexStore.getters[userGetterType.hubName]);
        const hubCode = computed(() => vuexStore.getters[userGetterType.hubCode]);
        const isMapControlPage = computed(() => vuexStore.getters['app/isMapControlPage']);
        const isHQ = computed(() => vuexStore.state.mapControl.isHQ);
        const getHubs = async () => {
            try {
                await vuexStore.dispatch('hubSelector/getHubs');
            }
            catch (error) {
                vuexStore.dispatch(snackbarActionType.showError, error);
            }
        };
        /**
         * 사용자 이름 클릭 이벤트 핸들러
         */
        const handleClickUserName = () => ({
            name: routeName.USER_MANAGEMENT_PAGE,
            params: {
                userId: userId.value,
                pageType: pageTypeList.DETAIL.value,
            },
        });
        const handleClickLogout = () => {
            vuexStore.dispatch(userActionType.logout);
        };
        /** [2023.02.22 기준]
         * 팝업창인 경우 : 지도관제화면 리로드
         * 일반창인 경우 : HCR 홈화면
         * 참고노션: https://www.notion.so/barogohq/GNB-1dccb4d2bdf0450e929d35631562ddb7
         */
        const handleClickLogo = () => {
            if (isMapControlPage.value && window.opener) {
                window.location.reload();
            }
            else {
                router.push({
                    name: routeName.WELCOME,
                }).catch(({ name }) => {
                    if (name === 'NavigationDuplicated') {
                        router.go(-1);
                    }
                });
            }
        };
        onMounted(async () => {
            try {
                await getHubs();
            }
            catch (error) {
                vuexStore.dispatch(snackbarActionType.showError, error);
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 로고 "),
                _createElementVNode("div", { class: "logo" }, [
                    _createElementVNode("img", {
                        src: "/svg/gnb-logo.svg",
                        class: "logo-img",
                        onClick: handleClickLogo
                    })
                ]),
                (isMapControlPage.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('common.map_control_header_title')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" GNB "),
                _createVNode(HubSelector, { class: "root-hub-selector" }),
                _renderSlot(_ctx.$slots, "default"),
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode(" 본사 아이디 표시 === 본사관리자가 관리자CS 타고 들어 옴 표기 "),
                    (isHQ.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" 본사 아이디: " + _toDisplayString(isHQ.value) + " ", 1 /* TEXT */),
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mx-2 brg-color-grey-550" }, " | ", -1 /* CACHED */))
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" mdi-account ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [1]
                    }),
                    (userName.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(userName.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_component_router_link, {
                        title: "유저 아이디",
                        class: "ml-1 mr-2 a-link2",
                        to: handleClickUserName()
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" (" + _toDisplayString(userId.value) + ") ", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"]),
                    _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(userLevelNameKr.value) + " 사용자) ", 1 /* TEXT */),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mx-2 brg-color-grey-550" }, " | ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" mdi-home-variant ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [2]
                        }),
                        _createCommentVNode(" 총판명 "),
                        _createElementVNode("span", {
                            title: '소속총판:' + distributorId.value
                        }, _toDisplayString(distributorName.value), 9 /* TEXT, PROPS */, _hoisted_7),
                        _cache[3] || (_cache[3] = _createTextVNode(" / ")),
                        _createCommentVNode(" 허브명 "),
                        _createElementVNode("span", {
                            title: '소속허브:' + hubCode.value
                        }, _toDisplayString(hubName.value), 9 /* TEXT, PROPS */, _hoisted_8)
                    ]),
                    _createElementVNode("span", _hoisted_9, [
                        (isMapControlPage.value)
                            ? (_openBlock(), _createBlock(MapConfigButton, { key: 0 }))
                            : _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                onClick: handleClickLogout
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode(" mdi-logout ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [4]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.logout')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "size-xs": true
                                    }
                                ]
                            ])
                    ])
                ])
            ]));
        };
    }
});
